import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import store from "@/store";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";
import { maskCurrency, maskCurrencyToFloat } from "@/common/utils/mask";

import {
	planPriceList,
	planPriceCreate,
	planPricePatch,
	planPriceDelete,
} from "@/common/api/rest/plan/price";

import type {
	PlanPriceType,
	PlanPricePayloadType,
} from "@/common/types/plan/price";

import { PanelTheme } from "@/common/themes";
import {
	breadcrumbSimple,
	baseModal,
	baseTable,
	iconMenu,
	svgIcon,
} from "@/common/components";

import FormPlanPrice from "@/components/forms/form-plan-price.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'price',
  setup(__props) {

const { t, tm, locale } = useI18n();
const router = useRouter();
const route = useRoute();

const tableData = ref<PlanPriceType[]>([]);
const selected = ref<PlanPriceType | null>(null);
const payload = ref<PlanPricePayloadType | null>(null);

const limit = ref<number>(6);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalEdit = ref(false);
const showModalDel = ref(false);
const payloadValid = ref(false);
const loading = ref(false);

const planId = computed(() => route.params.plan as string);

const breadcrumbList = computed(() => [
	{
		key: "register",
		label: t("common.labels.registrations"),
		url: "/register",
	},
	{
		key: "plans",
		label: t("common.labels.plans"),
		url: "/register/plan",
	},
	{
		key: "edit",
		label: t("common.labels.edit"),
	},
]);

const menuList = computed(() => [
	{
		key: "infos",
		icon: "field",
		label: t("collection.labels.infos"),
		url: `/register/plan/${planId.value}/edit`,
	},
	{
		key: "price",
		icon: "no-image",
		label: "Preços",
		url: `/register/plan/${planId.value}/price`,
	},
	{
		key: "term",
		icon: "no-image",
		label: "Termos",
		url: `/register/plan/${planId.value}/term`,
	},
	{
		key: "module",
		icon: "no-image",
		label: "Módulos",
		url: `/register/plan/${planId.value}/module`,
	},
]);

const tableHeader = computed(() => [
	{ key: "name", label: t("common.labels.name") },
	{ key: "status", label: t("common.labels.status") },
	{ key: "currency", label: t("common.labels.currency") },
	{ key: "price", label: t("common.labels.price") },
	{ key: "frequency", label: "Frequência" },
]);

const statusOptions = computed(() => ({
	ACTIVE: t("common.labels.active"),
	INACTIVE: t("common.labels.inactive"),
}));

const frequencyOptions = computed(() => ({
	MONTHLY: "Mensal",
	SEMESTER: "Semestral",
	YEARLY: "Anual",
}));

const currencies = computed(
	() => tm("enums.currencies") as Record<string, string>,
);

async function changeMenu(url: string) {
	router.push(url);
}

function back() {
	router.push(`/register/plan`);
}

function formatCurrency(value: number, currency: any) {
	const price = Number.parseFloat(value?.toString()).toFixed(2);
	return maskCurrency(price, currency);
}

function fetchData() {
	planPriceList(planId.value, {
		page: page.value,
		limit: limit.value,
		search: search.value,
	})
		.then((response) => {
			const { success, data, message } = response;
			if (success) {
				tableData.value = data.list.map((item: PlanPriceType) => {
					const newPrice = item.price ? item.price / 100 : 0;
					return { ...item, price: newPrice };
				});

				pages.value = data.infos.pages;
				total.value = data.infos.total;
				searched.value = data.infos.count;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function changePage(value: number) {
	page.value = value;
	fetchData();
}

function searchItem(value: string) {
	search.value = value;
	fetchData();
}

function addItem() {
	showModalAdd.value = true;
}

function addItemCancel() {
	showModalAdd.value = false;
	payload.value = null;
}

function addItemConfirm() {
	if (!payload.value) return;

	store.commit("SET_LOADING", true);

	const priceStr = String(payload.value.price)
		.replace(/\D/g, "")
		.replace(".", "")
		.replace(",", "");

	const priceCents = Math.round(parseFloat(priceStr));

	console.log("priceStr", priceStr, "priceCents", priceCents);

	const newPayload = {
		...payload.value,
		plan_id: planId.value,
		price: priceCents,
	};

	planPriceCreate(newPayload)
		.then((response) => {
			const { success, data, message } = response;

			if (success) {
				toast({ message: message, type: "success" });
				addItemCancel();
				fetchData();
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function editItem(data: PlanPriceType) {
	showModalEdit.value = true;
	selected.value = data;
	payload.value = null;
}

function editItemCancel() {
	showModalEdit.value = false;
	selected.value = null;
	payload.value = null;
}

function editItemConfirm() {
	if (!selected.value || !payload.value || !payloadValid.value) return;

	store.commit("SET_LOADING", true);

	let newPayload = { ...payload.value };

	if (Object.keys(payload.value).find((key) => key === "price")) {
		const priceStr = String(payload.value.price)
			.replace(/\D/g, "")
			.replace(".", "")
			.replace(",", "");
		const priceCents = Math.round(parseFloat(priceStr));

		newPayload = {
			...newPayload,
			price: priceCents,
		};
	}

	planPricePatch(selected.value.price_id, newPayload)
		.then((response) => {
			const { success, message } = response;

			if (success) {
				toast({ message: message, type: "success" });
				editItemCancel();
				fetchData();
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function removeItem(data: PlanPriceType) {
	selected.value = data;
	showModalDel.value = true;
}

onMounted(() => {
	fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "plans",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("plan.labels.plan_edit")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(iconMenu), {
          tabs: menuList.value,
          active: "price",
          size: "3rem",
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (changeMenu($event)))
        }, null, 8, ["tabs"]),
        _createVNode(_unref(baseTable), {
          header: tableHeader.value,
          data: tableData.value,
          limit: limit.value,
          page: page.value,
          pages: pages.value,
          total: total.value,
          searched: searched.value,
          loading: loading.value,
          options: true,
          del: true,
          edit: true,
          "onChange:page": _cache[2] || (_cache[2] = ($event: any) => (changePage($event))),
          onSearching: _cache[3] || (_cache[3] = ($event: any) => (searchItem($event))),
          "onBtn:add": _cache[4] || (_cache[4] = ($event: any) => (addItem())),
          "onBtn:edit": _cache[5] || (_cache[5] = ($event: any) => (editItem($event))),
          "onBtn:del": _cache[6] || (_cache[6] = ($event: any) => (removeItem($event)))
        }, {
          status: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(statusOptions.value[data.status]), 1)
          ]),
          currency: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(currencies.value[data.currency]), 1)
          ]),
          frequency: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(frequencyOptions.value[data.frequency]?.toUpperCase()), 1)
          ]),
          price: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(formatCurrency(data.price, data.currency)), 1)
          ]),
          _: 1
        }, 8, ["header", "data", "limit", "page", "pages", "total", "searched", "loading"]),
        _createVNode(_unref(baseModal), {
          show: showModalAdd.value,
          title: "ADICIONAR PREÇO",
          "show-button-confirm": true,
          "button-confirm": _unref(t)('common.labels.save'),
          "button-close": _unref(t)('common.labels.cancel'),
          onClose: _cache[9] || (_cache[9] = ($event: any) => (addItemCancel())),
          onConfirm: _cache[10] || (_cache[10] = ($event: any) => (addItemConfirm()))
        }, {
          content: _withCtx(() => [
            _createVNode(FormPlanPrice, {
              data: selected.value,
              "onUpdate:data": _cache[7] || (_cache[7] = ($event: any) => (payload.value = $event)),
              onValidate: _cache[8] || (_cache[8] = ($event: any) => (payloadValid.value = $event))
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["show", "button-confirm", "button-close"]),
        _createVNode(_unref(baseModal), {
          show: showModalEdit.value,
          title: "EDITAR PREÇO",
          "show-button-confirm": true,
          "button-confirm": _unref(t)('common.labels.save'),
          "button-close": _unref(t)('common.labels.cancel'),
          onClose: _cache[13] || (_cache[13] = ($event: any) => (editItemCancel())),
          onConfirm: _cache[14] || (_cache[14] = ($event: any) => (editItemConfirm()))
        }, {
          content: _withCtx(() => [
            _createVNode(FormPlanPrice, {
              data: selected.value,
              "is-patch": true,
              "onUpdate:data": _cache[11] || (_cache[11] = ($event: any) => (payload.value = $event)),
              onValidate: _cache[12] || (_cache[12] = ($event: any) => (payloadValid.value = $event))
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["show", "button-confirm", "button-close"])
      ])
    ])
  ]))
}
}

})